export var BackdropWithLogoStatus;
(function (BackdropWithLogoStatus) {
    BackdropWithLogoStatus["ORDERED"] = "ORDERED";
    BackdropWithLogoStatus["UPLOADED"] = "UPLOADED";
    BackdropWithLogoStatus["IN_PROGRESS"] = "IN_PROGRESS";
    BackdropWithLogoStatus["READY"] = "READY";
    BackdropWithLogoStatus["CANCELLED"] = "CANCELLED";
})(BackdropWithLogoStatus || (BackdropWithLogoStatus = {}));
